import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const FilterForm = styled.form`
    padding: 0 16px;
`

export const FilterGroupWrapper = styled.div`
    display: flex;
    min-width: 390px;
`

export const FilterGroupContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    &.real-filter-group {
        /* background-color: var(--color-gray-50); */
        /* border: 1px solid var(--color-gray-200); */
        background-color: rgba(200, 200, 200, 0.1);
        border: 1px solid rgba(180, 180, 180, 0.1);
        border-radius: 5px;
        padding: 12px 0 12px 12px;
    }
`

export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
`

export const FilterGroupItemWrapper = styled.div``

export const PropertySettingWrapper = styled.div`
    min-width: 390px;
    width: auto;
`

export const PropertySettingTitle = styled.p`
    margin-bottom: 8px;
    font-weight: 600;
    font-size: var(--font-size-normal);
    color: var(--color-black);
`

export const PropertyFooter = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-top: 8px;
    gap: 8px;
`

export const PropertyAdderIcon = styled(IconFont)`
    color: var(--color-main);
    margin-right: 6px;
`

export const ListItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
`
